import { DiscountType } from '@ca/common'
import { useTranslation } from 'react-i18next'
import Button from '@ui/buttons/Button'
import PriceInfo from '@/price/PriceInfo'
import SectionRow from '@ui/elements/SectionRow'

import { discountToIcon, highlightVariant } from './styles'

export type DiscountOptionStatus =
  | 'default'
  | 'active'
  | 'disabled'
  | 'attention'

interface Props {
  option: DiscountType
  status: DiscountOptionStatus
  info?: string
  price?: number
  onPress: () => void
}

export default function DiscountOption({
  option,
  status,
  info,
  price,
  onPress,
}: Props) {
  const { t } = useTranslation(['ui', 'order'])
  const text = `order:discounts.${option}.option`

  const isActive = status === 'active'
  const isAttention = status === 'attention'
  const isDisabled = status === 'disabled'

  return (
    <SectionRow
      icon={discountToIcon[option]}
      disabled={isDisabled}
      title={t(`${text}.title`)}
      desc={!isActive ? t(`${text}.desc`) : undefined}
      info={
        isActive || isAttention || option === 'credit'
          ? t(`${text}.info`, {
              info,
            })
          : undefined
      }
      variant={highlightVariant[status || 'default']}
      onPress={onPress}
      actionComponent={
        isActive ? (
          price ? (
            <PriceInfo size="default" value={price} />
          ) : null
        ) : (
          <Button
            noninteractive
            variant="outlined"
            size="xs"
            label={t(`${text}.cta`)}
            disabled={isDisabled}
          />
        )
      }
    />
  )
}
